<template>
  <transition name="partner-list">
    <section v-if="displayKeys.length > 0 && isPartnersLive" class="mb-64">
      <h3 v-if="showHeader" class="text-h4 mb-16">Highlighted care through our partners</h3>
      <transition-group tag="div" name="partner-tiles" class="flex overflow-x-scroll lg:overflow-x-visible hide-scrollbar pb-24">
        <div v-for="key in displayKeys" :key="key" class="partner-tiles-item">
          <PoppinsBHPartnerTile
            :logoImage="ALL_PARENT_PARTNER_TILES[key].logoImage"
            :companyName="ALL_PARENT_PARTNER_TILES[key].companyName"
            :headerText="ALL_PARENT_PARTNER_TILES[key].headerText"
            :bodyText="ALL_PARENT_PARTNER_TILES[key].bodyText"
            :ctaText="ALL_PARENT_PARTNER_TILES[key].ctaText"
            :ctaLink="ALL_PARENT_PARTNER_TILES[key].ctaLink"
            class="w-[369px] h-[275px] mr-16"
            @close="closeTile(key)"
            @ctaClicked="ctaClicked(key)"
          />
        </div>
      </transition-group>
      <a class="button button-text mt-16" href="/explore/partners">More partners</a>
    </section>
  </transition>
</template>

<script lang="ts">
import Vue from 'vue';
import PoppinsBHPartnerTile from './BHPartnerTile.vue';
import partners from '@/lib/partners';
import partnersData from '@/lib/partners.data';

export default Vue.extend({
  name: 'BHPartnersList',
  components: { PoppinsBHPartnerTile },
  inject: ['accountID'],
  props: {
    showHeader: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data(): any {
    return {
      isPartnersLive: partners.isPartnersLive,
      ALL_PARENT_PARTNER_TILES: partnersData.ALL_PARENT_PARTNER_TILES(),
      displayKeys: [],
    };
  },
  mounted() {
    if (this.isPartnersLive) this.displayKeys = partners.getPartners(this.accountID);
  },
  methods: {
    closeTile(key) {
      // log a cookie indicating the partner should no longer be shown
      partners.dismissPartner(this.accountID, key);

      // attempt to pull a new tile (if there are any left that we can display).
      // omit any *current* display keys, including the one we just dismissed.
      const currentKeys = [...this.displayKeys]; // sending in a copy so that splicing later does not affect test expectations
      const [replacementKey] = partners.getPartners(this.accountID, 1, false, currentKeys);

      if (!replacementKey && this.displayKeys.length === 1) {
        // we have no replacement and we just dismissed the last tile.
        // don't pop the tile from the list because that will cause component height to drop suddenly.
        // instead, just mark isPartnersLive to indicate that we no longer have tiles to display.
        this.isPartnersLive = false;
        return;
      }

      const dismissedIndex = this.displayKeys.findIndex((displayKey) => displayKey === key);
      this.displayKeys.splice(dismissedIndex, 1);
      if (replacementKey) this.displayKeys.push(replacementKey);
    },
    ctaClicked(key) {
      partners.partnerClicked(key);
    },
  },
});
</script>
<style scoped>
.partner-tiles-item {
  transition: all 0.3s;
  display: inline-block;
  margin-right: 10px;
}

.partner-tiles-enter-active {
  transition-delay: 0.3s;
}

.partner-tiles-enter,
.partner-tiles-leave-to {
  opacity: 0;
}

.partner-tiles-leave-active {
  position: absolute;
}

.partner-list-leave-active {
  /*
  Setting max-height to 350 as a reasonable guess to the actual
  height of the BHPartnersList component.
  - .partner-card is 275px
  - Header height is roughly 24px
  - Adding some 'padding' on top of that
  This should provide a 'wipe-up' looking transition-out effect.
  */
  max-height: 350px;
  opacity: 1;
  transition: all 0.3s;
}

.partner-list-leave-to {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
}
</style>
